<template>
    <div class="passenger-trip-wrapper">
        <transition name="fade" mode="out-in">
            <template v-if="isRequesting && !isPendingReservationHome">
                <RequestTrip></RequestTrip>
            </template>
            <template v-else-if="isPendingReservationHome">
                <ReservationHomeStatus></ReservationHomeStatus>
            </template>
            <template v-else>
                <template  v-if="isWaitingRequest">
                    <RequestWaiting></RequestWaiting>
                </template>
                <template v-else>
                    <template v-if="trip">
                        <div v-if="trip.frontState === TRIP_STATE.ACCEPTED && !trip.llegando">
                            <WaitingForTrip></WaitingForTrip>
                        </div>
                        <div v-if="trip.frontState === TRIP_STATE.ACCEPTED && trip.llegando">
                            <TripArrived></TripArrived>
                        </div>
                        <div v-if="trip.frontState === TRIP_STATE.RIDEUP || trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION">
                            <OnTrip></OnTrip>
                        </div>
                    </template>
                </template>
            </template>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RequestTrip from '../elements/passenger/RequestTrip.vue';
import RequestWaiting from '../elements/passenger/RequestWaiting.vue';
import WaitingForTrip from '../elements/passenger/WaitingForTrip.vue';
import TripArrived from '../elements/passenger/TripArrived.vue';
import OnTrip from '../elements/passenger/OnTrip.vue';
import ReservationHomeStatus from '../elements/passenger/ReservationHomeStatus.vue';

export default {
    name: 'passengerTrip',
    props: [

    ],
    data () {
        return {

        };
    },

    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            trip: 'passenger/actualTrip',
            isRequesting: 'passenger/isRequesting',
            isWaitingRequest: 'passenger/isWaitingRequest',
            isPendingReservationHome: 'passenger/isPendingReservationHome'
        })
    },

    mounted () {
        this.language = this.$getLang();
    },

    methods: {
    },
    components: {
        RequestTrip,
        RequestWaiting,
        WaitingForTrip,
        TripArrived,
        OnTrip,
        ReservationHomeStatus
    }
};
</script>

<style scoped>
    .passenger-trip-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2000;
        pointer-events: none;
    }

    .passenger-trip-wrapper > * {
        pointer-events: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/sections/PassengerTrip.vue